export default "__VITE_ASSET__DkghkEK8__"